import { isNumber, isUndefined } from 'lodash-es'
import { publicURL } from 'utils'
import Model from './Model'
import i18next from 'i18next'

/**
 * Handles "clean" and legacy data types from the User's tablet_options field.
 */
export default class TabletOptions extends Model {

	/** @type string|boolean */ newOrderSound
	/** @type boolean */ newOrderAlert
	/** @type boolean */ futureOrderAlert
	/** @type string */ alertSound
	/** @type boolean */ loopSound
	/** @type boolean */ louderSound
	/** @type boolean */ flashScreen
	/**
	 * @var {number}
	 * 0 means "anytime"
	 */
	newOrderWhen
	/** @type number */ doableTime
	/** @type string */ sort
	/** @type boolean */ enableCompleted
	/** @type boolean */ caffeine

	//Sort of ordered by... category? similarity? leaving the weirdest ones at the bottom
	static get SOUNDS() {
		return Object.freeze({
			DING       : i18next.t('Classic ding'),
			POSITIVE   : i18next.t('Positive alert'),
			WARM       : i18next.t('Warm alert'),
			BRIGHT     : i18next.t('Bright alert'),
			MODERN_RING: i18next.t('Modern ring'),
			PHONE_RING : i18next.t('Phone ring'),
			DOOR_BELL  : i18next.t('Door bell'),
			ORGAN      : i18next.t('Synth organ'),
			FAIRY_WAND : i18next.t('Fairy wand'),
			HARP_TONES : i18next.t('Harp tones'),
			EIGHT_BIT  : i18next.t('8bit victory'),
			FANFARE    : i18next.t('Fanfare'),
			WHISTLE    : i18next.t('Whistle'),
			SIREN      : i18next.t('Emergency siren'),
			YAHOO      : i18next.t('Yahoo!'),
		})
	}

	constructor(attrs) {
		super(attrs)
		const castBool     = value => (value === true || value == 'true')
		const castInt      = value => parseInt(isNumber(value)? value : (value? value.match(/\d+/)[0] : 0))
		const handleLegacy = (value, defValue, caster) => (isUndefined(value) || value === null)? defValue : caster(value)

		this.newOrderSound   = handleLegacy(attrs.newOrderSound, 'DING', v => v === true? 'DING' : v) //converts from the old true|false to the new format soundFile|false
		this.loopSound       = handleLegacy(attrs.loopSound, false, castBool)
		this.louderSound     = handleLegacy(attrs.louderSound, false, castBool)
		this.newOrderAlert   = handleLegacy(attrs.newOrderAlert, true, castBool)
		this.futureOrderAlert= handleLegacy(attrs.futureOrderAlert, false, castBool)
		this.flashScreen     = handleLegacy(attrs.flashScreen, false, castBool)
		this.newOrderWhen    = handleLegacy(attrs.newOrderWhen, 0, v => v == 'anytime'? 0 : castInt(v))
		this.doableTime      = handleLegacy(attrs.doableTime, 60, castInt)
		this.sort            = handleLegacy(attrs.sort, 'due', String)
		this.enableCompleted = handleLegacy(attrs.enableCompleted, true, castBool)
		this.caffeine        = handleLegacy(attrs.caffeine, false, castBool)
	}

	selectedSoundFile() {
		return !this.newOrderSound? '' : TabletOptions.soundFile(this.newOrderSound, this.loopSound, this.louderSound)
	}

	static fromState({ settings: { settings } }) {
		return new TabletOptions(settings)
	}
}

TabletOptions.SOUNDS_SEPARATE_LOOPABLE = [
	'WARM',
	'DOOR_BELL',
	'ORGAN',
	'SIREN',
	'WHISTLE'
]

/**
 * @param {string} sound
 * @param {boolean} loop
 * @param {boolean} loud
 */
TabletOptions.soundFile = (sound, loop = false, loud = false) => {
	let filename = sound.toLowerCase()
	if (TabletOptions.SOUNDS_SEPARATE_LOOPABLE.indexOf(sound) >= 0) {
		filename += loop? '_loopable' : '_single'
	}
	if (loud) {
		filename = `louder/${filename}`
	}
	return publicURL(`media/alerts/${filename}.mp3`)
}
